import { React } from 'react';
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';

import "./index.scss";

import ProfileAvatar from "../../../../components/ui/ProfileAvatar";
import Button from "../../../../components/ui/Button";
import SkeletonLoader from "../../../ui/SkeletonLoader";

import { businessImpactCriticalIcon, businessImpactHighIcon, businessImpactMediumIcon, businessImpactLowIcon, businessTypeIcon } from "../../../../utils/icons";

import { formatNumber, getOrganizationImageUrl, formatDate, getloggedInUserType } from "../../../../utils/util";

const OrganizationListView = ({organizationList, selectedCustomer, isLoading}) => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    return (
        <Row>
            <Col md="12">
                {
                    isLoading ?
                        <div className="list-view-container organization-list-view-table p-3 mt-3">
                            <SkeletonLoader type={"line"} count={5} currentPage={"organizationList"} />
                        </div>                        
                    :
                    <div className="list-view-container organization-list-view-table p-3 mt-3">
                        <Table responsive="lg">
                            <thead>
                                <tr>
                                    <th>{t('organizationPage.listView.organization')}</th>
                                    <th>{t('organizationPage.listView.created')}</th>
                                    <th>{t('organizationPage.listView.newFindings')}</th>
                                    <th>{t('organizationPage.listView.porfolioRisk')}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    organizationList?.results.length > 0 && 
                                    organizationList?.results.map((data,index)=>{
                                        return (
                                            <motion.tr
                                                key={index}
                                                initial={{ opacity: 0, y: 20 }}
                                                // whileInView={{ opacity: 1, y: 0 }}
                                                // viewport={{ once: true }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                            >
                                                <td>
                                                    <ProfileAvatar type="domain" name={data.name} imageUrl={getOrganizationImageUrl(data)} />
                                                    <div className="organization-status">
                                                        {data?.business_impact === "critical" && <p className="crictical">{t("organizationPage.BusinessImpact")} <span className="businessimpact-type"><span className="icon">{businessImpactCriticalIcon()}</span>{data?.business_impact}</span></p>}
                                                        {data?.business_impact === "high" && <p className="high">{t("organizationPage.BusinessImpact")} <span className="businessimpact-type"><span className="icon">{businessImpactHighIcon()}</span>{data?.business_impact}</span></p>}
                                                        {data?.business_impact === "medium" && <p className="medium">{t("organizationPage.BusinessImpact")} <span className="businessimpact-type"><span className="icon">{businessImpactMediumIcon()}</span>{data?.business_impact}</span></p>}
                                                        {data?.business_impact === "low" && <p className="low">{t("organizationPage.BusinessImpact")} <span className="businessimpact-type"><span className="icon">{businessImpactLowIcon()}</span>{data?.business_impact}</span></p>}
                                                        <p className="porfolio">{t("organizationPage.BusinessType")} <span className="businessimpact-type"><span className="icon">{businessTypeIcon()}</span>{data?.type}</span></p>
                                                    </div>
                                                </td>
                                                <td>
                                                    {formatDate(data.created_at)}
                                                </td>
                                                <td>
                                                    <div className="finding-list">
                                                        <ul type="none" className="m-0 p-0">
                                                            <li className="d-flex justify-content-between">
                                                                <span>{t("organizationPage.assetDiscovery")}</span>
                                                                <span>{formatNumber(data?.stats?.new_findings?.asset_discovery)}</span>
                                                            </li>
                                                            <li className="d-flex justify-content-between">
                                                                <span>{t("organizationPage.externalDetectedVulnerabilities")}</span>
                                                                <span>{formatNumber(data?.stats?.new_findings?.external_detected_vulnerabilities)}</span>
                                                            </li>
                                                            <li className="d-flex justify-content-between">
                                                                <span>{t("organizationPage.DarkWeb")}</span>
                                                                <span>{formatNumber(data?.stats?.new_findings?.darkweb)}</span>
                                                            </li>
                                                            <li className="d-flex justify-content-between">
                                                                <span>{t("organizationPage.concerningExposures")}</span>
                                                                <span>{formatNumber(data?.stats?.new_findings?.concerning_exposures)}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="risk-count">
                                                        <span className="critical">{t("organizationPage.critical")} {formatNumber(data?.stats?.domain_portfolio_risks?.critical_risk)}</span>
                                                        <span className="high">{t("organizationPage.high")} {formatNumber(data?.stats?.domain_portfolio_risks?.high_risk)}</span>
                                                        <span className="medium">{t("organizationPage.medium")} {formatNumber(data?.stats?.domain_portfolio_risks?.low_risk)}</span>
                                                        <span className="low">{t("organizationPage.low")} {formatNumber(data?.stats?.domain_portfolio_risks?.medium_risk)}</span>
                                                    </div> 
                                                </td>
                                                <td>
                                                    <div className='organization-list-view d-flex'>
                                                        <Button buttonText={"View Details"} buttonType="secondary" buttonClicked={() => {
                                                            if( getloggedInUserType() === "internal") {                                                        
                                                                navigate(`/${selectedCustomer?.value}/organization/details/${data?.organization_id}`)
                                                            } else {
                                                                navigate(`/organization/details/${data?.organization_id}`)
                                                            }
                                                        }}/>
                                                        <Button buttonText={"View Scan"} buttonType="primary" buttonClicked={()=>{
                                                            if(getloggedInUserType() === "internal") {
                                                                navigate(`/scan-info/exposure/dashboard?customer=${selectedCustomer?.value}&organization=${data?.organization_id}&domain=all&scanId=null`)
                                                            } else {
                                                                navigate(`/scan-info/exposure/dashboard?customer=all&organization=${data?.organization_id}&domain=all&scanId=null`)
                                                            }
                                                        }}/>
                                                    </div>
                                                </td>
                                            </motion.tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                }                
            </Col>
        </Row>
    )
}

export default OrganizationListView;